import React from "react";
import styled from 'styled-components';
import { Link } from "react-router-dom";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

import constants from "../../const";
import { helper } from "../common/helper";
import ScenesDropDownMenu from "./ScenesDropDownMenu";

const CardContainer = styled(Link)`
    display: block;
    width: 100%;
    background: white;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    text-decoration: none;
    color: inherit;
    cursor: pointer;
    z-index: 10;

    &:hover {
        box-shadow: 0 8px 24px rgba(15, 118, 110, 0.2);
        transform: translateY(-4px);
        text-decoration: none;
    }
`;

const ImageGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    width: 100%;
    height: 200px;
    background: #f5f5f5;
    position: relative;
    overflow: hidden;
    z-index: 20;
`;

const ImageItem = styled.div`
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: #e0e0e0;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.3s ease;
    }

    ${CardContainer}:hover & img {
        transform: scale(1.05);
    }
`;

const BadgeContainer = styled.div`
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.7);
    color: white;
    font-size: 12px;
    font-weight: 600;
    padding: 4px 8px;
    border-radius: 4px;
    backdrop-filter: blur(4px);
`;

const DateBadge = styled(BadgeContainer)`
    bottom: 8px;
    right: 8px;
`;

const ViewsBadge = styled(BadgeContainer)`
    top: 8px;
    left: 8px;
    font-size: 14px;
`;

const CardContent = styled.div`
    padding: 8px 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 6px;
    border-top: 1px solid #f0f0f0;
`;

const CardTitle = styled.h3`
    font-size: 13px;
    font-weight: 700;
    color: #1a1a1a;
    margin: 0;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

const SceneCount = styled.span`
    background: linear-gradient(135deg, #0f766e 0%, #06b6d4 100%);
    color: white;
    font-size: 11px;
    font-weight: 600;
    padding: 2px 6px;
    border-radius: 4px;
    white-space: nowrap;
`;

const PrivacyIconWrapper = styled.div`
    display: flex;
    align-items: center;
    color: #0f766e;
    min-width: 18px;

    svg {
        font-size: 16px !important;
    }
`;

const MenuWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    min-width: 28px;
`;

export default function PlaylistCard(props) {
    var images = [];
    if (props.playlist.scenes) {
        for (var img in props.playlist.scenes) {
            if (img > 3) break;
            images.push(
                `https://sus-store.s3.us-east-2.amazonaws.com/sus-media/scenes/${helper.pad(
                    props.playlist.scenes[img],
                    4
                )}/preview.webp`
            );
        }
    }
    
    let date = new Date(props.playlist?.created);
    date.setDate(date.getDate());
    let formattedDate = date.getDate() + "-" + constants.MONTHS[date.getMonth()] + "-" + date.getFullYear();

    return (
        <CardContainer to={`/playlist/${props.playlist.id}`}>
            <ImageGrid>
                <ImageItem>
                    {images[0] && <img src={images[0]} alt="Playlist preview 1" onError={(e) => e.target.style.display = 'none'} />}
                </ImageItem>
                <ImageItem>
                    {images[1] && <img src={images[1]} alt="Playlist preview 2" onError={(e) => e.target.style.display = 'none'} />}
                </ImageItem>
                <ImageItem>
                    {images[2] && <img src={images[2]} alt="Playlist preview 3" onError={(e) => e.target.style.display = 'none'} />}
                </ImageItem>
                <ImageItem>
                    {images[3] && <img src={images[3]} alt="Playlist preview 4" onError={(e) => e.target.style.display = 'none'} />}
                </ImageItem>
                <DateBadge onClick={(e) => e.preventDefault()}>
                    {formattedDate}
                </DateBadge>
                <ViewsBadge onClick={(e) => e.preventDefault()}>
                    0 views
                </ViewsBadge>
            </ImageGrid>
            <CardContent>
                <CardTitle>{props.playlist.title}</CardTitle>
                <PrivacyIconWrapper onClick={(e) => e.preventDefault()}>
                    {props.playlist.privacy == 1 ? (
                        <VisibilityIcon sx={{ fontSize: '16px' }} />
                    ) : (
                        <VisibilityOffIcon sx={{ fontSize: '16px' }} />
                    )}
                </PrivacyIconWrapper>
                <SceneCount onClick={(e) => e.preventDefault()}>
                    {`${props.playlist.scenes ? props.playlist.scenes.length : 0} scenes`}
                </SceneCount>
                <MenuWrapper onClick={(e) => e.preventDefault()}>
                    <ScenesDropDownMenu settings={props.settings} refresh={props.refresh} />
                </MenuWrapper>
            </CardContent>
        </CardContainer>
    );
}
